// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Z3ed","label":"CategoryService_label__3GD1m","location":"CategoryService_location__1rhB_"};